"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATURE_RATING = void 0;
exports.MATURE_RATING = 4;
var isMatureStory = function (story) {
    return (story === null || story === void 0 ? void 0 : story.rating) >= exports.MATURE_RATING;
};
exports.default = isMatureStory;
